import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAPI, postAPI } from "../../service/http-service";
import { notificationEndpoint } from "../../service/endpointConfig/notificationEndpoint";

export interface notificationResponse {
  data: any;
  message: string | undefined;
  errors: [string] | null;
}

export interface notificationState {
  loading: boolean;
  notificationResponse: notificationResponse;
  error: string | undefined;
}

const initialState: notificationState = {
  loading: false,
  error: undefined,
  notificationResponse: {
    data: undefined,
    message: undefined,
    errors: null,
  },
};

export const notificationAction = createAsyncThunk(
  "notification/sendNotification",
  async (notificationData: any) => {
    try {
      let response;
      switch (notificationData.apiAction) {
        case "list":
          response = await getAPI(notificationEndpoint.list);
          break;
        case "franchisee":
          response = await getAPI(notificationEndpoint.franchisee);
          break;
        case "notificationCount":
          response = await getAPI(notificationEndpoint.notificationCount);
          break;
        case "getNotificationList":
          response = await getAPI(notificationEndpoint.getNotificationList);
          break;
        case "template":
          response = await getAPI(
            `${notificationEndpoint.template}${
              notificationData?.type ? `?type=${notificationData?.type}` : ""
            }`
          );
          break;
        case "notificationHistory":
          response = await getAPI(
            `${notificationEndpoint.notificationHistory}${
              notificationData?.type ? `/${notificationData?.type}` : ""
            }`
          );
          break;
        case "templateById":
          response = await getAPI(
            `${notificationEndpoint.template}/${notificationData?.templateId}`
          );
          break;
        case "ciName":
          response = await getAPI(notificationEndpoint.ciName);
          break;
        case "batchName":
          response = await getAPI(
            `${notificationEndpoint.batchName}${notificationData?.param}`
          );
          break;
        case "studentName":
          response = await getAPI(
            `${notificationEndpoint.studentName}${
              notificationData?.param ? notificationData?.param : ""
            }`
          );
          break;
        case "sendEmail":
          response = await postAPI(
            `${notificationEndpoint.sendEmail}`,
            notificationData.formValues
          );
          break;
        case "sendSMS":
          response = await postAPI(
            `${notificationEndpoint.sendSMS}`,
            notificationData.formValues
          );
          break;
        case "courseLevel":
          response = await getAPI(notificationEndpoint.courseLevel);
          break;
        case "sendNotification":
          response = await postAPI(
            `${notificationEndpoint.sendNotification}`,
            notificationData.formValues
          );
          break;
        case "acknowledgeNotification":
          response = await postAPI(
            `${notificationEndpoint.acknowledge}`,
            notificationData.formValues
          );
          break;
      }
      return response;
    } catch (err) {
      return err;
    }
  }
);

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    addObj: (state, action: any) => {
      state.notificationResponse.data.push({ success: false });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(notificationAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(notificationAction.fulfilled, (state, { payload }: any) => {
      state.loading = false;
      state.notificationResponse = payload;
    });
    builder.addCase(notificationAction.rejected, (state, action) => {
      state.loading = false;
      // This is kept purposefully to check the data coming while error
      if (action.payload) {
        state.notificationResponse.data = action.payload;
      } else {
        state.error = action.error.message;
      }
    });
  },
});

const notificationReducer = notificationSlice.reducer;
export default notificationReducer;
